import React, { useEffect, useMemo } from "react";
import { Formik, useFormikContext } from "formik";
import { OrderedMap } from "immutable";
import { v4 as uuidv4 } from "uuid";
import usePluginEntities from "hooks/usePluginEntities";
import SearchFilterBanner from "views/components/searchbar/SearchFilterBanner";
const SyncQueryString = ({ queryString }) => {
  const { setFieldValue } = useFormikContext();
  useEffect(() => {
    setFieldValue("queryString", queryString);
  }, [queryString, setFieldValue]);
  return null;
};
function SearchFiltersFormControls({
  filters,
  onChange,
  hideFiltersPreview = () => {
  },
  queryString = "",
  isParentMutable = true
}) {
  var _a;
  const searchFiltersPlugin = (_a = usePluginEntities("eventDefinitions.components.searchForm")) != null ? _a : [];
  const pluggableControls = searchFiltersPlugin.map((controlFn) => controlFn()).filter((control) => !!control);
  useEffect(() => hideFiltersPreview(!pluggableControls.length), []);
  const initialFilters = useMemo(() => {
    const searchFilters = OrderedMap(
      filters.map((filter) => {
        const frontendId = filter.id || uuidv4();
        return [frontendId, { ...filter, frontendId }];
      })
    );
    return { searchFilters, queryString };
  }, [filters, queryString]);
  if (!pluggableControls.length)
    return /* @__PURE__ */ React.createElement(SearchFilterBanner, { onHide: () => hideFiltersPreview(true), pluggableControls });
  const SearchFiltersComponent = pluggableControls[0].component;
  const handleSearchFiltersChange = ({ searchFilters }) => {
    const formFilters = searchFilters.map(({ frontendId, ...filter }) => filter);
    onChange(formFilters);
  };
  return /* @__PURE__ */ React.createElement(Formik, { onSubmit: handleSearchFiltersChange, initialValues: initialFilters }, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SyncQueryString, { queryString }), /* @__PURE__ */ React.createElement(SearchFiltersComponent, { isParentMutable })));
}
export default SearchFiltersFormControls;
